import React, { useState } from 'react';
import VisitanteList from '../components/VisitanteList';
import VisitanteForm from '../components/VisitanteForm';
import { Container, Typography, Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { actionButtonSx, pageTitleSx } from '../styles/uiTokens';

function VisitantesPage() {
  const [refreshList, setRefreshList] = useState(false);
  const [editingVisitante, setEditingVisitante] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const handleVisitanteAdded = () => {
    setRefreshList(prev => !prev);
    setEditingVisitante(null);
    setShowForm(false);
  };

  const handleEditVisitante = (visitante) => {
    setEditingVisitante(visitante);
    setShowForm(true);
  };

  const handleCancelEditVisitante = () => {
    setEditingVisitante(null);
    setShowForm(false);
  };

  const handleVisitanteDeleted = () => {
    setRefreshList(prev => !prev);
  };

  const handleShowForm = () => {
    setEditingVisitante(null);
    setShowForm(true);
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4" gutterBottom sx={pageTitleSx}>
          Gerenciar Visitantes
        </Typography>
        {!showForm && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleShowForm}
            sx={actionButtonSx}
          >
            Adicionar Visitante
          </Button>
        )}
      </Box>

      {showForm && (
        <VisitanteForm
          onVisitanteAdded={handleVisitanteAdded}
          initialData={editingVisitante}
          onCancelEdit={handleCancelEditVisitante}
        />
      )}

      {!showForm && (
        <VisitanteList
          refresh={refreshList}
          onEdit={handleEditVisitante}
          onVisitanteDeleted={handleVisitanteDeleted}
        />
      )}
    </Container>
  );
}

export default VisitantesPage;
